export default function displayCalSettings(form){
    this.popup(form, "calSettingsForm");
}